module.exports = __webpack_public_path__ + "img/reference04.30de4898.jpg";